var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState, useRef } from 'react';
import { Modal, Input, Button, message } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';
import trimStart from 'lodash/trimStart';
import UploadImage from './UploadIamge';
import { IconStars } from './../IconFont';
var oss_base_url = 'https://focus-desktop.s3.cn-north-1.jdcloud-oss.com';
var icon1 = '/statics/images/feedback/icon_chat_jd@3x.png';
var icon2 = '/statics/images/feedback/icon_chat_jd2@3x.png';
var icon3 = '/statics/images/feedback/icon_chat_kx@3x.png';
var icon4 = '/statics/images/feedback/icon_chat_kx2@3x.png';
var icon5 = '/statics/images/feedback/icon_chat_ph@3x.png';
var icon6 = '/statics/images/feedback/icon_chat_ph2@3x.png';
var icon7 = '/statics/images/feedback/icon_chat_js@3x.png';
var icon8 = '/statics/images/feedback/icon_chat_js2@3x.png';
var icon9 = '/statics/images/feedback/icon_chat_sq@3x.png';
var icon10 = '/statics/images/feedback/icon_chat_sq2@3x.png';
var iconListF = function (t) { return [
    {
        title: t('feedback.dissatisfied'),
        icon: IconStars,
    },
    {
        title: t('feedback.disappointment'),
        icon: IconStars,
    },
    {
        title: t('feedback.not-bad'),
        icon: IconStars,
    },
    {
        title: t('feedback.good'),
        icon: IconStars,
    },
    {
        title: t('feedback.very-satisfied'),
        icon: IconStars,
    },
]; };
export default function FeedbackModal(_a) {
    var _this = this;
    var t = _a.t, userData = _a.userData, visible = _a.visible, onCancel = _a.onCancel, onSubmit = _a.onSubmit, uploadImageControler = _a.uploadImageControler, logFiles = _a.logFiles, isHiddenSelectLog = _a.isHiddenSelectLog, headNetCheckBtn = _a.headNetCheckBtn, headNetCheckCallback = _a.headNetCheckCallback, ossBaseUrl = _a.ossBaseUrl;
    var iconList = iconListF(t);
    var _b = useState(''), value = _b[0], setValue = _b[1];
    var _c = useState({}), valueData = _c[0], setValueData = _c[1];
    var _d = useState('请对我们的产品进行打分'), satisfaction = _d[0], setSatisfaction = _d[1];
    var _e = useState('#F8840A'), colorText = _e[0], setColorText = _e[1];
    var _f = useState(Number(-1)), id = _f[0], setId = _f[1];
    var _g = useState(0), num = _g[0], setNum = _g[1];
    var _h = useState({}), numData = _h[0], setNumData = _h[1];
    var _j = useState(200), maxNum = _j[0], setMaxNum = _j[1];
    var _k = useState('1'), tab = _k[0], setTab = _k[1];
    var _l = useState(true), submitDisabled = _l[0], setSubmitDisabled = _l[1];
    var _m = useState(false), submitLoading = _m[0], setSubmitLoading = _m[1];
    var inputRef = useRef(null);
    var uploadImageRef = useRef({ getParams: Function });
    var maxLen = 1; // 输入字符不可为空
    // 点击取消弹框消失
    var handleCancel = function (e) {
        onCancel();
        setValueData({});
        setTab('1');
        setSatisfaction('请对我们的产品进行打分');
        setNumData({});
        setId(-1);
    };
    // 反馈问题value
    var feedback = function (e) {
        var _a, _b;
        var v = trimStart(e.target.value);
        setValue(v);
        setValueData(__assign(__assign({}, valueData), (_a = {}, _a[tab] = v, _a)));
        setNumData(__assign(__assign({}, numData), (_b = {}, _b[tab] = v.length, _b)));
        if (v.length < maxLen) {
            document
                .getElementsByClassName('primary-btn')[0]
                .setAttribute('style', 'cursor:not-allowed');
            return;
        }
        else {
            document
                .getElementsByClassName('primary-btn')[0]
                .setAttribute('style', 'cursor:pointer');
        }
    };
    var lightHeightIcon = function (item, index) {
        setSatisfaction(item.title);
        setId(index);
    };
    var ver = '';
    function bro() {
        var broName = 'Runing';
        var strStart = 0;
        var strStop = 0;
        var temp = '';
        var userAgent = window.navigator.userAgent; // 包含以下属性中所有或一部分的字符串：appCodeName,appName,appVersion,language,platform
        // FireFox
        if (userAgent.indexOf('Firefox') !== -1) {
            strStart = userAgent.indexOf('Firefox');
            temp = userAgent.substring(strStart);
            broName = temp.replace('/', ' 版本号');
        }
        // Edge
        if (userAgent.indexOf('Edge') !== -1) {
            /* broName = 'Edge浏览器'; */
            strStart = userAgent.indexOf('Edge');
            temp = userAgent.substring(strStart);
            broName = temp.replace('/', ' 版本号');
        }
        // IE浏览器
        if (userAgent.match(/msie ([\d.]+)/)) {
            /* broName = 'IE浏览器'; */
            var s = userAgent.match(/msie ([\d.]+)/);
            var res = 'IE ' + s[1];
            broName = res + res.replace(/[^0-9.]/gi, '');
        }
        // 360极速模式可以区分360安全浏览器和360极速浏览器
        if (userAgent.indexOf('WOW') !== -1 &&
            userAgent.indexOf('NET') < 0 &&
            userAgent.indexOf('Firefox') < 0) {
            if (navigator.javaEnabled()) {
                broName = '360安全浏览器-极速模式';
            }
            else {
                broName = '360极速浏览器-极速模式';
            }
        }
        // 360兼容
        if (userAgent.indexOf('WOW') !== -1 &&
            userAgent.indexOf('NET') !== -1 &&
            userAgent.indexOf('MSIE') !== -1 &&
            userAgent.indexOf('rv') < 0) {
            broName = '360兼容模式';
        }
        // Chrome浏览器
        if (userAgent.match(/Chrome\/([\d.]+)/)) {
            /* broName = 'Chrome浏览器'; */
            strStart = userAgent.indexOf('Chrome');
            strStop = userAgent.indexOf('Safari');
            temp = userAgent.substring(strStart, strStop);
            broName = temp.replace('/', ' 版本号');
        }
        // safari
        if (userAgent.match(/Version\/([\d.]+).*Safari/)) {
            strStop = userAgent.indexOf('Safari');
            temp = userAgent.substring(strStop);
            broName = temp.replace('/', ' 版本号');
        }
        // opera
        if (userAgent.match(/Opera.([\d.]+)/)) {
            strStop = userAgent.indexOf('Opera');
            temp = userAgent.substring(strStop);
            broName = temp.replace('/', ' 版本号');
        }
        ver = broName;
        return broName;
    }
    // 点击切换tabs
    var callback = function (key) {
        console.log(key);
        setTab(key);
    };
    useEffect(function () {
        var verifyLength = valueData[tab] && valueData[tab].length >= maxLen ? false : true;
        var disabled = tab === '2' ? id === -1 || verifyLength : verifyLength;
        setSubmitDisabled(disabled);
    }, [valueData, tab, id]);
    // 意见反馈点击提交
    var confirmEdit = function () { return __awaiter(_this, void 0, void 0, function () {
        var newValue, extendParams, params, data, error_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    // let list = window.document.cookie.split('feedback.;');
                    // let filterList = list.filter((item) => {
                    //     return item.substring(1, 13) === 'focus-token=';
                    // });
                    setSubmitLoading(true);
                    newValue = valueData[tab].trim();
                    setNumData(__assign(__assign({}, numData), (_a = {}, _a[tab] = newValue.length, _a)));
                    if (newValue.length < maxLen) {
                        setValueData(__assign(__assign({}, valueData), (_b = {}, _b[tab] = newValue, _b)));
                        inputRef.current.focus();
                        setSubmitLoading(false);
                        message.error(t('feedback.submit-no-less-than-words'));
                        return [2 /*return*/];
                    }
                    if (!onSubmit) {
                        return [2 /*return*/];
                    }
                    document.getElementsByClassName('primary-btn')[0].setAttribute('style', 'cursor:pointer');
                    bro();
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, uploadImageRef.current.getParams()];
                case 2:
                    extendParams = _c.sent();
                    params = __assign({ expression: tab === '2' ? iconList[id].title : '', content: newValue, type: tab, system_name: 'focus-desktop', system_version: '1.0.0', device_model: ver, name: userData.realName || userData.teamUserInfo.realName, mobile: userData.teamUserInfo.mobile, company: userData.teamUserInfo.teamFullName || userData.teamUserInfo.teamShortName || '' }, extendParams);
                    return [4 /*yield*/, onSubmit(params)];
                case 3:
                    data = _c.sent();
                    // if (data && data.mobile === params.mobile) {
                    message.success(t('feedback.submitted-successfully'));
                    setValueData({});
                    setTab('1');
                    setSatisfaction('请对我们的产品进行打分');
                    setNumData({});
                    setId(-1);
                    setTimeout(function () {
                        onCancel();
                        handleCancel();
                    }, 100);
                    setSubmitLoading(false);
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _c.sent();
                    setSubmitLoading(false);
                    message.error(t('feedback.submit-failed'));
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    // 底部button
    var modalFooter = function () {
        return (React.createElement("div", null,
            React.createElement(Button, { style: { border: '1px solid #dee0e3', borderRadius: ' 4px', color: '#242931' }, onClick: handleCancel }, t('feedback.cancelText')),
            React.createElement(Button, { className: "primary-btn", type: "primary", style: {
                    border: 'none',
                    backgroundColor: ' @primary-color !important',
                    borderRadius: '4px',
                    fontSize: '14px',
                    color: '#ffffff',
                }, disabled: submitDisabled, onClick: confirmEdit, loading: submitLoading }, t('feedback.submit'))));
    };
    var showNetModal = function (params) {
        onCancel();
        if (typeof headNetCheckCallback === 'function') {
            headNetCheckCallback(params);
        }
    };
    return (React.createElement(Modal, { className: "feedbackModal", title: React.createElement("div", { className: "title-container" },
            React.createElement("div", { style: { fontWeight: 'bold' } }, t('feedback.feedback')),
            headNetCheckBtn && (React.createElement("div", { className: "net-check", onClick: showNetModal },
                React.createElement(GlobalOutlined, { className: "check-icon" }),
                React.createElement("span", { className: "check-text" }, "\u7F51\u7EDC\u68C0\u6D4B")))), visible: visible, onCancel: handleCancel, footer: modalFooter(), maskClosable: false },
        React.createElement("div", { className: "feedback-con" },
            React.createElement("div", { className: "feedback-header" },
                React.createElement("div", { className: "header-text" }, t('feedback.question-type')),
                React.createElement("div", { className: "header-tabs" },
                    React.createElement("span", { className: tab === '1' ? 'header-tab selected' : 'header-tab', onClick: function () { return callback('1'); } }, "\u95EE\u9898"),
                    React.createElement("span", { className: "line" }),
                    React.createElement("span", { className: tab === '2' ? 'header-tab selected' : 'header-tab', onClick: function () { return callback('2'); } }, "\u610F\u89C1"))),
            tab === '2' && (React.createElement("div", { className: "evaluation" },
                React.createElement("p", { className: "notice-text" }, satisfaction),
                React.createElement("div", { className: "icon" }, iconList.map(function (item, index) {
                    return (React.createElement("div", { key: index, className: index <= id ? 'default selected' : 'default', onClick: function () { return lightHeightIcon(item, index); } }, IconStars));
                })))),
            React.createElement("div", { style: { position: 'relative' } },
                React.createElement(Input.TextArea, { ref: inputRef, maxLength: 200, value: valueData[tab], onChange: feedback, placeholder: tab === '1' ? t('feedback.feedbackContent') : t('feedback.proposal'), style: { resize: 'none' } }),
                React.createElement("span", { className: "text-num" },
                    typeof valueData[tab] === 'string' && valueData[tab].length < maxLen && (React.createElement("span", { style: { color: '#8f959e', marginRight: '6px' } }, t('feedback.no-less-than-words'))),
                    React.createElement("span", null, numData[tab] || 0),
                    "/",
                    maxNum)),
            tab === '1' && uploadImageControler && (React.createElement(UploadImage, { innerRef: uploadImageRef, uploadImageControler: uploadImageControler, logFiles: logFiles, userData: userData, isHiddenSelectLog: isHiddenSelectLog })))));
}
//# sourceMappingURL=index.js.map